import { Navigate, Outlet } from 'react-router';

import { useAuthStore } from '@/store/auth.store';

/** Keeps already-verified users off the verify-email page. */
export function VerifyEmailRouteOutlet() {
	const emailIsVerified = useAuthStore((state) => state.user?.emailIsVerified);

	if (emailIsVerified) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}
